function ManagingMyHomeIcon () {
  return(
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1297_8774)">
        <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="#EFF8FA"/>
        <path d="M34.7871 14.1782H16.6956V46.7174H34.7871V14.1782Z" stroke="#323232" strokeWidth="1.4" strokeMiterlimit="10"/>
        <path d="M45.3408 46.7172H34.7882V22.6968L45.3408 28.2685V34.2661V46.7172Z" stroke="#323232" strokeWidth="1.4" strokeMiterlimit="10"/>
        <path d="M23.1762 24.7527H19.8138V28.1142H23.1762V24.7527Z" fill="#FFC524"/>
        <path d="M28.5705 24.7527H25.2081V28.1142H28.5705V24.7527Z" fill="#0C8188"/>
        <path d="M23.1762 18.4761H19.8138V21.8376H23.1762V18.4761Z" fill="#0C8188"/>
        <path d="M28.5705 18.4761H25.2081V21.8376H28.5705V18.4761Z" fill="#FFC524"/>
        <path d="M39.5013 37.375H36.8756V40H39.5013V37.375Z" fill="#0C8188"/>
        <path d="M43.5186 37.375H40.8929V40H43.5186V37.375Z" fill="#0C8188"/>
        <path d="M39.5013 33H36.8756V35.625H39.5013V33Z" fill="#0C8188"/>
        <path d="M43.5186 33H40.8929V35.625H43.5186V33Z" fill="#0C8188"/>
        <path d="M23.1762 30.5522H19.8138V33.9138H23.1762V30.5522Z" fill="#0C8188"/>
        <path d="M28.5705 30.5522H25.2081V33.9138H28.5705V30.5522Z" fill="#FFC524"/>
        <path d="M23.1762 36.354H19.8138V39.7155H23.1762V36.354Z" fill="#0C8188"/>
        <path d="M28.5705 36.354H25.2081V39.7155H28.5705V36.354Z" fill="#0C8188"/>
        <path d="M31.6187 43.582V17.1949L32.5139 15.6875V43.582H31.6187Z" fill="#0C8188"/>
      </g>
      <defs>
        <clipPath id="clip0_1297_8774">
          <rect width="60" height="60" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ManagingMyHomeIcon;

